import 'notivue/notification.css'
import 'notivue/animations.css'
import "./assets/main.css";

import {type App, createApp} from "vue";
import {createPinia} from "pinia"
import router from "./router/index.ts"
import uiPlugin from "@nuxt/ui/vue-plugin";
import MyApp from "./App.vue";
import {AllCommunityModule, ModuleRegistry} from "ag-grid-community";

import BaseWrapper from "@/components/base/BaseWrapper.vue";
import {ObjectPlugin} from "@vue/runtime-core";
import {setAxiosRouter} from "@/composables/axiosInstance.ts";

import {createNotivue} from 'notivue';

const notivue = createNotivue({

  limit: 2,
  // enqueue: true,
  // avoidDuplicates: true,
  notifications: {
    // global: {
    //   duration: 40000
    // }
  }
})

const myPlugin: ObjectPlugin = {
    install(app: App) {
        app.component("UWrapper", BaseWrapper);
    }
}

ModuleRegistry.registerModules([AllCommunityModule]);
const app = createApp(MyApp);
app.use(notivue)
app.use(uiPlugin);
app.use(myPlugin)
app.use(createPinia())
app.use(router);
setAxiosRouter(router);

// await useAuthStore().initUser();

app.mount("#app");
